<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import { fetchDataBot }  from '../../api.js';
    import UserStore from '../../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte';
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 

    export let params;

    let bot_id = params.id;
    
    let isLoading = false;
    let data = [];
    
    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }       
        
        fetchPage();
        
    })

    async function fetchPage() {

        isLoading = true;
        let postData = {};
        postData.action = 'bots_get';
        postData.token = $UserStore.data;
        postData.bot_id = bot_id

        let response = await fetchDataBot(postData);
        if (response.data) {

            data = [...response.data]

        }

        isLoading = false;

    }

    async function saveBot(item) {

        isLoading = true;
        let postData = {};
        postData.action = 'bots_save';
        postData.token = $UserStore.data;
        postData.bot_id = bot_id
        postData.bot = item;

        let response = await fetchDataBot(postData);

        isLoading = false;
    }


    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">

        <TopInfo />   
        
        <div class="dash-list">        
            <div class="orders-top">
                {#each data as item, index} 
                <div class="orders-top-up">
                    <h1 class="text-[20px] font-bold">{$_('bot.bots.title')}: {item.name} ({item.id})</h1>
                </div>
                <div class="locations_desc">{$_('bot.bots.desc')}</div>
                <form class="bot-edit-form text-start flex flex-col gap-3" on:submit|preventDefault={() => saveBot(item)}>
                    <div class="flex flex-col">
                        <div class="form-group">
                            <label class="font-bold text-[16px]">{$_('bot.bots.name')}</label>
                            <input type="text" bind:value={item.name} />
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <div class="form-group flex flex-col">
                            <label class="font-bold text-[16px]">{$_('bot.bots.description')}</label>
                            <textarea bind:value={item.description} class="border border-gray-400 rounded-[5px] p-5"></textarea>
                        </div>
                    </div>


                    <div class="flex flex-col">
                        <div class="form-group flex flex-col">
                            <label class="font-bold text-[16px]">{$_('bot.bots.whatsapp_number')}</label>
                            <input bind:value={item.number} class="border border-gray-400"/>
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <div class="form-group flex flex-col">
                            <label class="font-bold text-[16px]">{$_('bot.bots.whatsapp_client_id')}</label>
                            <input bind:value={item.client_id} class="border border-gray-400"/>
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <div class="form-group flex flex-col">
                            <label class="font-bold text-[16px]">{$_('bot.bots.whatsapp_client_secret')}</label>
                            <input bind:value={item.client_secret} class="border border-gray-400"/>
                        </div>
                    </div>
        
                    <div class="form-group flex flex-col gap-3">
                        <label class="font-bold text-[16px]">{$_('bot.bots.options')}</label>
                        {#each item.options as option, index}
                            <div class="flex flex-col gap-2 items-start border border-gray-200 rounded-[5px] p-3 {option.checked ? 'bg-gray-50' : ''}">
                                <div class="flex gap-1 items-start items-center justify-center">
                                    <input type="checkbox" bind:checked={option.checked} class="w-[20px]">
                                    <span>{option.name}</span>
                                </div>
                                
                                {#if option.checked}                                
                                    {#if option.code === 'wordpress_ecom'}
                                        <!-- HERE ADD WooCommerce API fields -->
                                        <div class="woocommerce-fields m-[10px]">
                                            <label>WooCommerce API Key</label>
                                            <input type="text" bind:value={option.woocommerce_api_key}>
                    
                                            <label>API Secret</label>
                                            <input type="text" bind:value={option.woocommerce_api_secret}>

                                            <label>URL</label>
                                            <input type="text" bind:value={option.woocommerce_url}>
                                        </div>
                                    {/if}
                    
                                    {#if option.code === 'schedule_meetings'}
                                        <!-- Here add Google Calendar API fields -->
                                        <div class="google-calendar-fields">
                                            <label>Google Calendar Client ID</label>
                                            <input type="text" bind:value={option.google_client_id}>
                    
                                            <label>Client Secret</label>
                                            <input type="text" bind:value={option.google_client_secret}>
                                        </div>
                                    {/if}
                                {/if}
                            </div>
                        {/each}
                    </div>
                    
        
                    <div class="form-actions flex">
                        <button type="submit" class="create_button">{$_('bot.bots.save')}</button>
                        <button type="button" class="create_button" on:click={() => deleteBot(item.id)}>
                            {$_('bot.bots.delete')}
                        </button>
                    </div>
                </form>
                {/each}
            </div>
        </div>
    </div>
</div>
